<script setup>
const props = defineProps({
  name: {
    type: String,
    default: 'name',
  },
});

const { handleChange, handleReset, errorMessage, setErrors } = useField(
  () => props.name,
  null,
  { initialValue: null },
);

const widgetRef = ref(null);

let smartCaptcha;
let widgetId;

const { t } = useI18n();

// widget init
onMounted(async () => {
  try {
    const { captchaInstance, captchaKey } = await useYCaptcha();
    smartCaptcha = captchaInstance;

    widgetId = smartCaptcha.render(widgetRef.value, { sitekey: captchaKey });

    smartCaptcha.subscribe(widgetId, 'success', (token) => {
      handleChange(token);
    });
  } catch (error) {
    setErrors(t('form.errors.captchaLoad'));
  }
});
onBeforeUnmount(() => {
  smartCaptcha?.destroy(widgetId);
});

function reset() {
  smartCaptcha?.reset(widgetId);
  handleReset();
}

defineExpose({ reset });
</script>

<template>
  <div class="form-y-captcha">
    <div ref="widgetRef" class="form-y-captcha__widget" />

    <div v-if="errorMessage" class="form-y-captcha__error">
      <span class="form-y-captcha__font form-y-captcha__font--error">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-y-captcha {
  display: flex;
  flex-direction: column;
  gap: em(13);

  @include media-breakpoint-down(sm) {
    gap: em(9);
  }

  &__widget:empty {
    display: none;
  }

  &__error {
    color: $color-red-1;
  }

  &__font {
    &--error {
      font-size: em(18);
      line-height: em(20, 18);

      @include media-breakpoint-down(sm) {
        font-size: em(16);
        line-height: em(18, 16);
      }
    }
  }
}
</style>
